export class DropdownItem {
  text: string;
  value: string;
  disabled?: boolean;
}
